import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";

export default function DonationsIndex(props) {
  const [donations, setDonations] = useState(props.active_donations);
  const [archived, setArchived] = useState(props.archived_donations)
  const [saving, setSaving] = useState(false);
  const [showItems, setShowItems] = useState(false)

  useEffect(() => {
    setDonations(props.active_donations)
    setArchived(props.archived_donations)
  }, [])

  const activateItem = async (placeholder) => {
    let response = null
    try {
      response = await request(placeholder.id)
    } catch {
      Alert.show('error', 'Could not update item status')
      return
    }

    Alert.show('notice', 'Donation Item activated successfully')
    setTimeout(() => window.location.reload(), 1200)
  }

  const request = (id) => {
    return HTTP.patch(`/donations/archive/${id}`)
  }

  return (
    <React.Fragment>
      <div className="card">
          <div className="card-header flex-header">
            <h4 className="card-title">Active Donation Items</h4>
          </div>
        <div>
          <div className="list-group list-group-flush">
            {donations.map((donation, index) => (
              <div key={donation.id} className="list-group-item">
                <div className="list-group-item-body">
                  <div className="list-group-item-body-main">
                    <span>{donation.name}</span>
                  </div>
                </div>
                <div className="list-group-item-actions d-none-mobile">
                  <a
                    href={`/donations/${donation.id}`}
                    className="btn btn-sm btn-outline-primary"
                  >
                    View Donation Item
                  </a>
                  <a
                    href={`/donations/${donation.id}/edit`}
                    className="btn btn-sm btn-primary ml-2"
                  >
                    <i className="fa fa-pencil"></i> Edit Donation Item
                  </a>
                </div>
                <div className="dropdown">
                  <button
                    className="btn btn-primary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">
                      <a href={`/donations/${donation.id}`}>
                        View Donation Item
                      </a>
                    </li>
                    <li className="dropdown-item">
                      <a href={`/donations/${donation.id}/edit`}>
                        Edit Donation Item
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        {donations.length == 0 && (
          <div className="card-body">
            Let's get started with your first donation item :)
          </div>
        )}
      </div>

      {archived.length > 0 &&
      <div className="card">
          <div className="card-header flex-header">
            <h4 className="card-title">Archived Donation Items</h4>

            <div className="btn-group">
              <button onClick={() => setShowItems(!showItems)}
                name="button"
                className="btn btn-primary"
                type="button">
                {!showItems && <>Show Items</>}
                {showItems && <>Hide Items</>}
              </button>
            </div>
          </div>
        <div>
          {showItems &&
          <div className="list-group list-group-flush">
            {archived.map((donation, index) => (
              <div key={donation.id} className="list-group-item">
                <div className="list-group-item-body">
                  <div className="list-group-item-body-main">
                    <span>{donation.name}</span>
                  </div>
                </div>
                <div className="list-group-item-actions d-none-mobile">
                  <a
                    href={`/donations/${donation.id}`}
                    className="btn btn-sm btn-outline-primary"
                  >
                    View Donation Item
                  </a>
                  {!donation.locked &&
                  <a
                    href="#" onClick={() => activateItem(donation)}
                    className="btn btn-sm btn-primary ml-2"
                  >
                     Activate Donation Item
                  </a>
                  }
                </div>
                <div className="dropdown">
                  <button
                    className="btn btn-primary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">
                      <a href={`/donations/${donation.id}`}>
                        View Donation Item
                      </a>
                    </li>
                    {!donation.locked &&
                      <li className="dropdown-item">
                        <a href="#" onClick={() => activateItem(donation)}>
                          Activate Donation Item
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            ))}
          </div>
          }
        </div>
      </div>}
    </React.Fragment>
  );
}

DonationsIndex.propTypes = {
  donations: PropTypes.array,
};
